// Ui
export const TOGGLE_PRICES = 'TOGGLE_PRICES';
export const TOGGLE_ORDER_SUMMARY = 'TOGGLE_ORDER_SUMMARY';
export const TOGGLE_FILTER = 'TOGGLE_FILTER';
export const TOGGLE_CART = 'TOGGLE_CART';
export const TOGGLE_NAV = 'TOGGLE_NAV';
export const TOGGLE_ARTICLE_DETAIL = 'TOGGLE_ARTICLE_DETAIL';
export const LOCATION_CHANGE = 'LOCATION_CHANGE';
export const REDIRECT = 'REDIRECT';

// Cart
export const SET_CART = 'SET_CART';
export const CART_REQUEST = 'CART_REQUEST';
export const CART_REQUEST_SUCCESS = 'CART_REQUEST_SUCCESS';
export const CART_REQUEST_FAILURE = 'CART_REQUEST_FAILURE';
export const UPDATE_CART_ITEM_REQUEST = 'UPDATE_CART_ITEM_REQUEST';
export const UPDATE_CART_ITEM_SUCCESS = 'UPDATE_CART_ITEM_SUCCESS';
export const UPDATE_CART_ITEM_FAILURE = 'UPDATE_CART_ITEM_FAILURE';
export const RESET_CART_ITEM_ERROR = 'RESET_CART_ITEM_ERROR';

// User
export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const CLEAR_CURRENT_USER = 'CLEAR_CURRENT_USER';

// Auth
export const AUTHENTICATION_REQUEST = 'AUTHENTICATION_REQUEST';
export const AUTHENTICATION_REQUEST_SUCCESS = 'AUTHENTICATION_REQUEST_SUCCESS';
export const AUTHENTICATION_REQUEST_FAILURE = 'AUTHENTICATION_REQUEST_FAILURE';
export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGOUT_REQUEST_SUCCESS = 'LOGOUT_REQUEST_SUCCESS';
export const LOGOUT_REQUEST_FAILURE = 'LOGOUT_REQUEST_FAILURE';
export const LOGOUT = 'LOGOUT';

// Profile
export const PROFILE_REQUEST = 'PROFILE_REQUEST';
export const PROFILE_REQUEST_SUCCESS = 'PROFILE_REQUEST_SUCCESS';
export const PROFILE_REQUEST_FAILURE = 'PROFILE_REQUEST_FAILURE';
export const SET_CURRENT_PROFILE = 'SET_CURRENT_PROFILE';

// Order
export const SET_ORDER_WIZARD_VALUES = 'SET_ORDER_WIZARD_VALUES';
export const CLEAR_ORDER_WIZARD_VALUES = 'CLEAR_ORDER_WIZARD_VALUES';
export const SET_ACTIVE_ORDER = 'SET_ACTIVE_ORDER';
export const UPDATE_ACTIVE_ORDER = 'UPDATE_ACTIVE_ORDER';
export const CLEAR_ACTIVE_ORDER = 'CLEAR_ACTIVE_ORDER';

export const SET_PAYMENT_METHOD = 'SET_PAYMENT_METHOD';
export const PAY_ORDER_REQUEST = 'PAY_ORDER_REQUEST';
export const PAY_ORDER_SUCCESS = 'PAY_ORDER_SUCCESS';
export const PAY_ORDER_FAILURE = 'PAY_ORDER_FAILURE';
export const CREATE_STRIPE_SOURCE = 'CREATE_STRIPE_SOURCE';
export const CREATE_STRIPE_SOURCE_REQUEST = 'CREATE_STRIPE_SOURCE_REQUEST';
export const CREATE_STRIPE_SOURCE_FAILURE = 'CREATE_STRIPE_SOURCE_FAILURE';
export const CREATE_STRIPE_SOURCE_SUCCESS = 'CREATE_STRIPE_SOURCE_SUCCESS';

export const CREATE_ORDER_REQUEST = 'CREATE_ORDER_REQUEST';
export const CREATE_ORDER_SUCCESS = 'CREATE_ORDER_SUCCESS';
export const CREATE_ORDER_FAILURE = 'CREATE_ORDER_FAILURE';

export const ORDER_STATUS_REQUEST = 'ORDER_STATUS';
export const ORDER_STATUS_SUCCESS = 'ORDER_STATUS_SUCCESS';
export const ORDER_STATUS_FAILURE = 'ORDER_STATUS_FAILURE';

export const FLUSH_ORDER = 'FLUSH_ORDER';

// Tracking
export const INIT_SOCKET = 'INIT_SOCKET';
export const TRACK_DETAIL_CLICK = 'TRACK_DETAIL_CLICK';
export const TRACK_FILTER_ARTICLES = 'TRACK_FILTER_ARTICLES';



// WEBPACK FOOTER //
// ./src/actions/types.js